import { render, staticRenderFns } from "./payment-link-details.vue?vue&type=template&id=67861288&scoped=true&"
import script from "./payment-link-details.vue?vue&type=script&lang=js&"
export * from "./payment-link-details.vue?vue&type=script&lang=js&"
import style0 from "./payment-link-details.vue?vue&type=style&index=0&id=67861288&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67861288",
  null
  
)

export default component.exports